<template>
  <div class="drawer-close">
    <img src="../assets/chevron-left.svg" alt="<" />
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
  .drawer-close {
    background-color: #72c81e;
    border-radius: 50%;
    height: 36px;
    padding: 6px;
    width: 36px;
    transform: rotate(180deg);
  }
</style>
